export type PentestType = 'external' | 'internal' | 'web';

export interface PentestCalendarEvent {
  id?: number;
  customerId?: number;
  configId: number;
  customerName: string;
  name?: string;
  types: PentestType[];
  startDate: Date;
  endDate?: Date;
  interval?: number;
}

export namespace PentestCalendarEvent {
  export function mapFromApiValue(data: any): PentestCalendarEvent {
    return { ...data, types: (data.types ?? []).map((t: string) => t.toLowerCase()) };
  }
}
